/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'inferno-redux';
// actions used to manipulate application state
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import UDCEntryPhase from 'components/content/userdatacollection/phases/udcentry/udcentry';
import { advanceFrame } from 'redux/actions/content_status';
import { showLoader, setOutOfContent } from 'redux/actions/embed_status';
import { submitUDCData } from 'redux/actions/content_status';
import { displayScreen } from 'redux/actions/screen_status';




/* ========== ~~~~~~~~~~ USER DATA COLLECTION SCREEN: PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ contentStatus, settings, sessionStatus }, { contentId }) => ({
    isPubPortalPreview: settings.embedSettings.isPubPortalPreview,
    embedUUID: settings.embedSettings.embedUUID,
    userId: sessionStatus.userInfo.userId !== undefined ? sessionStatus.userInfo.userId : null,
    isActive: contentStatus[contentId]['status'] === 'active',
    dataFetchingPermitted: sessionStatus.dataFetchingPermitted,
    dmpCallsEnabled: sessionStatus.dmpCallsEnabled,
    contentSignature: contentStatus[contentId].uniqueState.contentSignature,
    udcId: contentStatus[contentId].uniqueState.udcId,
    ...contentStatus[contentId].uniqueState.contentProperties,
    phase: contentStatus[contentId].uniqueState.phase,
    city: !!sessionStatus.city ? sessionStatus.city : 'unknown',
    country: !!sessionStatus.country_name ? sessionStatus.country_name : 'unknown'
});

// map actions
const mapDispatchToProps = dispatch => ({
    advanceFrame: contentId => dispatch(advanceFrame(contentId)),
    showLoader: state => dispatch(showLoader(state)),
    submitUDCData: (contentId, udcData, isPubPortalPreview, callback) =>
        dispatch(submitUDCData(contentId, udcData, isPubPortalPreview, callback)),
    displayScreen: (screen) => dispatch(displayScreen(screen)),
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
// will be utilized from any component that wants to incorporate "Content" component
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UDCEntryPhase);
